import React, { useState, useEffect, useRef } from "react";
import Layout from "../../layouts";
import Header from "../../layouts/header";
import Footer from "../../layouts/footer";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";
import { showToast, showPDFToasts } from "../../utils/toast";
import ReconocimientoForm from "./ReconocimientoForm";
import ReconocimientoTable from "./ReconocimientoTable";
import CartaInstitucionalReconocimiento from "./CartaInstitucionalReconocimiento";
import CartaTrayectoriaInstitucional from "./CartaTrayectoriaInstitucional";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const ReconocimientosContainer = () => {
  const [vistaActual, setVistaActual] = useState("crear");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    document.body.classList.contains("sidebar-collapsed")
  );
  const [tipoCarta, setTipoCarta] = useState("institucional");
  const hoy = new Date();
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const printRef = useRef(null);
  const [data, setData] = useState({
    idempleado: null,
    nombreEmpleado: "",
    puesto: "",
    fecha: hoy.toISOString().split("T")[0],
    nombreResponsable: "",
    cargoResponsable: "",
    lugar: "",
    otroReconocimiento: "",
    descripcionReconocimiento: "",
    ciudad: "",
    motivosReconocimiento: "",
  });

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    const observer = new MutationObserver(() => {
      setSidebarCollapsed(
        document.body.classList.contains("sidebar-collapsed")
      );
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      observer.disconnect();
    };
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (name) => {
    setData((prev) => ({
      ...prev,
      reconocimientos: {
        ...prev.reconocimientos,
        [name]: !prev.reconocimientos[name],
      },
    }));
  };

  const handleGenerarPDF = () => {
    if (!data.nombreEmpleado) {
      showToast("Ingrese el nombre del empleado", "warning");
      return;
    }

    if (!data.nombreResponsable) {
      showToast("Ingrese el nombre del responsable", "warning");
      return;
    }

    handlePrint();
  };

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `Reconocimiento_${data.nombreEmpleado}`,
    pageStyle: `
    @page {
      size: letter portrait;
      margin: 2cm;
    }

    html, body {
      background: white !important;
      background-color: white !important;
      color: black !important;
    }
  `,
    onBeforePrint: async () => {
      setGenerandoPDF(true);
      showPDFToasts.generando();
    },

    onAfterPrint: async () => {
      setGenerandoPDF(false);
      const reconocimiento = await crearReconocimiento();
      if (reconocimiento) {
        showPDFToasts.success(
          "Reconocimiento generado y registrado correctamente"
        );
      }
    },

    onPrintError: () => {
      setGenerandoPDF(false);
      showPDFToasts.error("No fue posible generar el reconocimiento");
    },
  });

  const crearReconocimiento = async () => {
    try {
      const payload = {
        tipocarta: tipoCarta,
        fecha: data.fecha,
        nombre_responsable: data.nombreResponsable,
        cargo_responsable: data.cargoResponsable,
        observaciones: data.descripcionReconocimiento || "",
        estado: true,
        idempleado: data.idempleado,
        iddocumento: null,
      };

      const response = await axios.post(
        `${API}/reconocimientos/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("ERROR:", error.response?.data);
      showToast("Error al crear el reconocimiento", "error");
      return null;
    }
  };

  return (
    <Layout>
      <SEO title="Reconocimientos" />

      <div
        className="wrapper"
        style={{
          display: "flex",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Header />

          <main
            className="main-content site-wrapper-reveal"
            style={{
              flex: 1,
              backgroundColor: "#fff",
              marginLeft: isMobile
                ? "0"
                : sidebarCollapsed
                  ? "90px"
                  : "300px",
              transition: "margin-left 0.3s ease",
            }}
          >
            {/* Tabs */}
            <div
              style={{
                borderBottom: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
              }}
            >
              <div style={{ display: "flex" }}>
                <button
                  onClick={() => setVistaActual("crear")}
                  style={{
                    padding: "12px 24px",
                    border: "none",
                    backgroundColor:
                      vistaActual === "crear"
                        ? "#023047"
                        : "transparent",
                    color:
                      vistaActual === "crear"
                        ? "#fff"
                        : "#023047",
                    cursor: "pointer",
                  }}
                >
                  Crear Reconocimiento
                </button>

                <button
                  onClick={() => setVistaActual("listar")}
                  style={{
                    padding: "12px 24px",
                    border: "none",
                    backgroundColor:
                      vistaActual === "listar"
                        ? "#023047"
                        : "transparent",
                    color:
                      vistaActual === "listar"
                        ? "#fff"
                        : "#023047",
                    cursor: "pointer",
                  }}
                >
                  Ver Reconocimientos
                </button>
              </div>
            </div>

            {vistaActual === "crear" ? (
              <div
                style={{
                  display: "flex",
                  height: "calc(100vh - 130px)",
                  flexDirection: isMobile ? "column" : "row",
                }}
              >
                {/* Vista previa carta */}
                <div
                  style={{
                    flex: "0 0 70%",
                    overflow: "auto",
                    padding: "10px",
                  }}
                >
                  {tipoCarta === "institucional" ? (
                    <CartaInstitucionalReconocimiento
                      ref={printRef}
                      data={data}
                    />
                  ) : (
                    <CartaTrayectoriaInstitucional
                      ref={printRef}
                      data={data}
                    />
                  )}
                </div>

                {/* Formulario */}
                <ReconocimientoForm
                  data={data}
                  onChange={onChange}
                  tipoCarta={tipoCarta}
                  setTipoCarta={setTipoCarta}
                  handleCheckboxChange={handleCheckboxChange}
                  onPrint={handleGenerarPDF}
                  generandoPDF={generandoPDF}
                />
              </div>
            ) : (
              <ReconocimientoTable />
            )}
          </main>

          <Footer />
          <ScrollToTop />
        </div>
      </div>
    </Layout>
  );
};

export default ReconocimientosContainer;